/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_App_Anna_ProfessionInputs */

const en_marketing_app_anna_profession = /** @type {(inputs: Marketing_App_Anna_ProfessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masters in Speech Pathology`)
};

const es_marketing_app_anna_profession = /** @type {(inputs: Marketing_App_Anna_ProfessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maestría en Patología del Habla`)
};

/**
* | output |
* | --- |
* | "Masters in Speech Pathology" |
*
* @param {Marketing_App_Anna_ProfessionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const marketing_app_anna_profession = /** @type {((inputs?: Marketing_App_Anna_ProfessionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_App_Anna_ProfessionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_marketing_app_anna_profession(inputs)
	return en_marketing_app_anna_profession(inputs)
});